import type { FeatureFlagKey } from '@marketing-hub/shared';

export type NavItem = {
  to: string;
  label: string;
  /** Exact match for active state (default: prefix match for nested routes). */
  end?: boolean;
  minRole?: 'marketing' | 'admin' | 'owner';
  /** Hidden unless this feature flag is enabled (global or project). */
  featureFlag?: FeatureFlagKey;
};

export type NavGroup = {
  label: string;
  items: NavItem[];
};

/** Primary IA aligned with dashboard redesign — Werken first, outreach & systeem grouped. */
export const NAV_GROUPS: NavGroup[] = [
  {
    label: 'Werken',
    items: [
      { to: '/app/dashboard', label: 'Dashboard', end: true },
      { to: '/app/copilot', label: 'Assistent', featureFlag: 'copilot_v1' },
      { to: '/app/analytics', label: 'Analytics' },
      { to: '/app/leads', label: 'Leads' },
      { to: '/app/doelgroepen', label: 'Doelgroepen', featureFlag: 'audiences_v1' },
      { to: '/app/campagnes', label: 'Campagnes' },
      { to: '/app/pipeline', label: 'Pipeline' },
      { to: '/app/taken', label: 'Taken' },
    ],
  },
  {
    label: 'Outreach',
    items: [
      { to: '/app/inbox', label: 'Inbox' },
      { to: '/app/mailboxen', label: 'Mailboxen' },
      { to: '/app/deliverability', label: 'Deliverability' },
    ],
  },
  {
    label: 'Organisatie',
    items: [
      { to: '/app/accounts', label: 'Accounts' },
      { to: '/app/bedrijfs-dna', label: 'Bedrijfs-DNA' },
      { to: '/app/team', label: 'Team' },
      { to: '/app/projects', label: 'Projecten' },
    ],
  },
  {
    label: 'Systeem',
    items: [
      { to: '/app/integraties', label: 'Integraties' },
      { to: '/app/automations', label: 'Automations', featureFlag: 'automations_v1' },
      { to: '/app/instellingen/privacy', label: 'Instellingen' },
      { to: '/app/developer', label: 'Developer', minRole: 'marketing' },
      { to: '/app/scraper', label: 'Scraper' },
      { to: '/app/backlinks', label: 'Backlinks' },
    ],
  },
];

export function navItemActive(pathname: string, item: NavItem, isActive: boolean): boolean {
  if (item.to === '/app/campagnes') return pathname.startsWith('/app/campagnes');
  if (item.to === '/app/doelgroepen') return pathname.startsWith('/app/doelgroepen');
  if (item.to === '/app/bedrijfs-dna') return pathname.startsWith('/app/bedrijfs-dna');
  if (item.to.startsWith('/app/instellingen')) return pathname.startsWith('/app/instellingen');
  if (item.to === '/app/automations') return pathname.startsWith('/app/automations');
  if (item.to === '/app/copilot') return pathname.startsWith('/app/copilot');
  if (item.end) return isActive;
  return isActive || pathname.startsWith(`${item.to}/`);
}
